import { Component, Components } from "../../utils/components";
import axios from "../../../../node_modules/axios/index";
import { HtmlHelpers, AxiosHelpers } from "../../utils/helpers";
export class ListForm extends Component {
  constructor(element) {
    super(element);
    this.submitting = false;
    this.form = element.querySelector("form");
    this.totalPages = 0;
    this.pageNumber = 1;

    if (!this.form) {
      this.form = element;
    }

    this.parentSectionEl = this.loadMoreEl = this.element.closest("section");
    this.loadMoreEl = this.parentSectionEl.querySelector(".alm-btn-wrap");
    this.loadMoreSpanEls = this.loadMoreEl.querySelectorAll("span"); // Jquery may not work here.
  }

  init() {// Jquery may not work here
  }

  load() {
    this.bindFields();
    this.setCurrentPageInfo();
    this.revealHiddenResults();
  }

  toggleMoreLoading(state) {
    this.loadMoreEl.classList.toggle("loading", state);
  }

  toggleMoreDisabled(state) {
    this.loadMoreEl.classList.toggle("disabled", state);
  }

  bindFields() {
    const selects = this.form.querySelectorAll("select");

    for (const select of selects) {
      select.addEventListener("change", e => {
        e.preventDefault();
        this.submit(false);
      });
    }

    this.loadMoreEl.addEventListener("click", e => {
      this.pageNumber++;
      this.toggleMoreLoading(true);
      this.submit(true);
    });
  }

  setSubmitting(state) {
    this.submitting = state;
    this.form.classList.toggle("submitting", state);
  }

  isSubmitting() {
    return this.submitting;
  }

  beginSubmitting() {
    this.setSubmitting(true);
  }

  endSubmitting() {
    this.setSubmitting(false);
  }

  isSubmitting() {
    return this.submitting;
  }

  getQueryString(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value) {
        params.append(key, value);
      }
    }

    params.append("page", this.pageNumber);
    return params.toString();
  }

  setCurrentPageInfo() {
    const elements = document.querySelectorAll(".masonary-layout__grid");
    const lastElement = elements[elements.length - 1];
    this.pageNumber = parseInt(lastElement.getAttribute("data-page-number"));
    this.totalPages = parseInt(lastElement.getAttribute("data-total-pages"));
    this.totalCount = parseInt(lastElement.getAttribute("data-total-count"));
    this.showCount = parseInt(lastElement.getAttribute("data-show-count"));
    const isLastPage = this.totalPages <= this.pageNumber;
    this.toggleMoreDisabled(isLastPage);
    const spans = this.loadMoreSpanEls;
    spans[0].innerHTML = this.showCount;
    spans[1].innerHTML = this.totalCount;
    this.loadMoreEl.classList.add("ready");
  }

  revealHiddenResults() {
    const hiddenElements = this.parentSectionEl.querySelectorAll(".masonary-layout__item.hidden");
    hiddenElements.forEach(el => {
      el.classList.remove("hidden");
    });
  }

  hideResults() {
    const hiddenElements = this.parentSectionEl.querySelectorAll(".masonary-layout__item");
    hiddenElements.forEach(el => {
      el.classList.add("hidden");
    });
  }

  submit(append) {
    if (this.isSubmitting()) {
      return;
    }

    this.beginSubmitting();
    const queryString = this.getQueryString(this.form);
    const actionWithoutQuery = this.form.action.split('?')[0];
    const newUrl = actionWithoutQuery + (queryString.length > 0 ? "?" + queryString : "");
    history.replaceState(null, '', newUrl);
    const request = {
      method: 'POST',
      url: newUrl,
      headers: {
        'X-Requested-With': "XMLHttpRequest"
      },
      data: "page=" + this.pageNumber,
      maxRedirects: 1
    };

    if (!append) {
      this.hideResults();
    }

    axios.request(request).then(result => {
      // handle success
      this.endSubmitting();

      if (result.status === 200) {
        setTimeout(() => {
          const selector = "#list-form-results-wrapper";
          const targetEl = document.querySelector(selector);
          let html = HtmlHelpers.fragmentQuerySelector(result.data, selector);
          let el = document.createElement("div");
          el.innerHTML = html;

          if (!append) {
            targetEl.innerHTML = "";
          }

          targetEl.appendChild(el);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.revealHiddenResults();
            });
          });
          this.toggleMoreLoading(false);
          this.setCurrentPageInfo();
          Components.update();
        }, 600);
      }
    }).catch(err => {
      this.endSubmitting();
    });
  }

}
Components.data(ListForm, "listForm");